import { useLocation } from 'react-router-dom';

import { DEMO_CLUSTER_ID } from '@cast/utils';

import { getUser } from '@cast/infrastructure-auth';
import { getIsClusterDemoMode } from '@cast/infrastructure-demo';
import { Navigate } from 'components/router';
import { IS_DEV } from '@cast/constants';
import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { useExperiment } from 'core/experiments';

export const LandingRedirect = () => {
  const location = useLocation();
  const variant = useExperiment({ name: 'post-signup-redirect' });

  // If the user came from a branded login (e.g. brand=dbo), redirect to the
  // corresponding product page instead of the default dashboard.
  const brand = new URLSearchParams(location.search).get('brand');
  if (brand?.toLowerCase() === 'dbo') {
    return (
      <Navigate
        to={{
          pathname: PRODUCT_BASE_PATHS.dbo,
        }}
      />
    );
  }

  if (getUser()?.firstLogin && getIsClusterDemoMode() && !IS_DEV) {
    return (
      <Navigate
        to={{
          ...location,
          pathname:
            variant === '0'
              ? '/dashboard'
              : `/external-clusters/${DEMO_CLUSTER_ID}/available-savings`,
        }}
      />
    );
  }

  return (
    <Navigate
      to={{
        ...location,
        pathname: '/dashboard',
      }}
    />
  );
};
